module.exports = __webpack_public_path__ + "img/ks01.d45e0df0.png";